if (!customElements.get('jupityr-contact-confirmation')) {
  customElements.define('jupityr-contact-confirmation', class extends HTMLElement {
    connectedCallback() {
      this.updateConfirmation = () => {
        const submitted = this.formRoot?.querySelector('[data-form-root]')?.getAttribute('data-current-step') === 'success';
        this.dataset.submitted = String(submitted);
        this.querySelectorAll('[data-contact-success]').forEach(element => {
          element.hidden = !submitted;
        });
      };
      this.attachForm = () => {
        if (!this.isConnected) return;
        const formRoot = this.querySelector('shopify-forms-embed')?.shadowRoot;
        if (!formRoot || formRoot === this.formRoot) return;
        this.formObserver?.disconnect();
        this.formRoot = formRoot;
        this.formObserver = new MutationObserver(this.updateConfirmation);
        this.formObserver.observe(formRoot, {
          attributes: true,
          attributeFilter: ['data-current-step'],
          childList: true,
          subtree: true
        });
        this.updateConfirmation();
      };
      this.hostObserver = new MutationObserver(this.attachForm);
      this.hostObserver.observe(this, { childList: true, subtree: true });
      customElements.whenDefined('shopify-forms-embed').then(this.attachForm);
      this.attachForm();
    }

    disconnectedCallback() {
      this.hostObserver?.disconnect();
      this.formObserver?.disconnect();
      this.formRoot = null;
    }
  });
}
